import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack } from '@mui/material'
import React from 'react'
import { TextField } from 'src/Libs/inputs/formik'
import { InstallerFormModel } from '../../types'

/**
 * Component for installer name used in installation statement.
 * It requires formik context for the input fields.
 */
const Installer: React.VFC = () => {
  const { t } = useCustomTranslation()

  const installerForm: InstallerFormModel = {
    firstName: {
      name: 'installer.firstName',
      label: t('common.firstName'),
    },
    lastName: {
      name: 'installer.lastName',
      label: t('common.lastName'),
    },
  }

  return (
    <Stack spacing={2} direction="row">
      <TextField name={installerForm.firstName.name} label={installerForm.firstName.label} disabled />
      <TextField name={installerForm.lastName.name} label={installerForm.lastName.label} disabled />
    </Stack>
  )
}

export default Installer
